export const QUERY_KEYS = {
  USERS: ['users'] as string[],
  WALKS: ['walks'] as string[],
  EVENTS: ['events'] as string[],
  IDEAS: ['ideas'] as string[],
  INTERESTS: ['interests'] as string[],
  SCHOOLS: ['schools'] as string[],
  CAMPUS: ['campus'] as string[],
  CAMPUSES: ['campus'] as string[],
  APP_DOWNLOADS: ['app-downloads'] as string[],
  SPACES: ['spaces'] as string[],
  SPACE_MEMBERS: ['space-members'] as string[],
  SPACE_REQUESTS: ['space-requests'] as string[],
  ROLES: ['roles'] as string[],
  JOBS_STATUS: ['jobs-status'] as string[],
};

export const USER_ROLES = {
  ADMIN: '7891',
  STUDENT: '2356',
  FACULTY: '6473',
} as const;

export const WALK_STATUSES = {
  PENDING: 'pending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
} as const;

export const EVENT_TYPES = {
  WALK: 'walk',
  MEETING: 'meeting',
  SOCIAL: 'social',
  ACADEMIC: 'academic',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
} as const;
